import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';


@Component({
})
export default class SBKurukuru extends Mixins(SBComponentVue) {
    @Prop({
        type: Boolean,
        default: false,
    })
    public value!: boolean;
}
